import React  from 'react';
import SessionManager from '../../routes/SessionManager';
import SitesHawkEye from './SitesHawkEye';

function DashboardOwners () {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');
    let site = user.site_selected;

    return (
        <React.Fragment>
            <div className="page-container">
                {site && <SitesHawkEye></SitesHawkEye>}
            </div>
        </React.Fragment >
    )
    
}
export default DashboardOwners;